$(document).ready(function () {
  $(".mak-video-slider").slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    prevArrow:
      "<img class='prev ars-prv1 slick-prev' src='https://cdn.shopify.com/s/files/1/0803/8468/8473/files/Arrow_2.png?v=1729863606'>",
    nextArrow:
      "<img class='next ars-nxt1 slick-next' src='https://cdn.shopify.com/s/files/1/0803/8468/8473/files/Arrow_1.png?v=1729863606'>",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1.3,
          slidesToScroll: 1,
          infinite: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.3,
          slidesToScroll: 1,
          infinite: false,
        },
      },
    ],
  });
  $(".mak_card-slider").slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    prevArrow:
      "<img class='prev ars-prv1 slick-prev' src='https://cdn.shopify.com/s/files/1/0803/8468/8473/files/Arrow_2.png?v=1729863606'>",
    nextArrow:
      "<img class='next ars-nxt1 slick-next' src='https://cdn.shopify.com/s/files/1/0803/8468/8473/files/Arrow_1.png?v=1729863606'>",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1,
          infinite: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1,
          infinite: false,
        },
      },
    ],
  });
});
var coll = document.querySelectorAll(".mak-collapsible");

for (let i = 0; i < coll.length; i++) {
  coll[i].addEventListener("click", function () {
    // Close all other collapsibles
    for (let j = 0; j < coll.length; j++) {
      if (coll[j] !== this) {
        var otherContent = coll[j].parentElement.nextElementSibling;
        var otherSvg = coll[j].querySelector(".mak-rotate");
        coll[j].classList.remove("active");
        otherContent.style.maxHeight = null;
        otherSvg.style.transform = ""; // Reset the transform
      }
    }

    // Toggle the clicked collapsible
    var content = this.parentElement.nextElementSibling;
    var svg = this.querySelector(".mak-rotate");

    this.classList.toggle("active");

    if (content.style.maxHeight) {
      content.style.maxHeight = null;
      svg.style.transform = ""; // Reset the transform when closed
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
      svg.style.transform = "rotate(180deg)"; // Apply the transform when open
    }
  });
}
function openMak(evt, cityName, sectionId) {
  var section = document.querySelector(`[data_section_id="${sectionId}"]`);
  var tabContents = section.getElementsByClassName("mak_new-tabcontent");
  var tabButtons = section.getElementsByClassName("mak_new-tablinks");

  for (var i = 0; i < tabContents.length; i++) {
    tabContents[i].style.display = "none";
  }

  for (var i = 0; i < tabButtons.length; i++) {
    tabButtons[i].className = tabButtons[i].className.replace(" active", "");
  }

  section.querySelector(`#${cityName}`).style.display = "block";

  evt.currentTarget.className += " active";
}

document.querySelectorAll("[data_section_id]").forEach(function (section) {
  section.querySelector("#defaultOpen").click();
});

$(document).ready(function () {
  console.log("DOM is ready");

  // Function to calculate discounted price
  function calculateDiscountedPrice(originalPrice, discountPercentage) {
    return (originalPrice * (1 - discountPercentage / 100)).toFixed(2);
  }

  // Function to update price elements based on subscription selection
  function updatePriceElements(isSubscriptionSelected, isOneTimeSelected) {
    const selectedPriceText = $("input.quantity-radio:checked").data(
      "compare-price"
    );

    if (selectedPriceText) {
      const selectedPrice = parseFloat(
        selectedPriceText.replace(/[^\d.-]/g, "")
      );

      if (!isNaN(selectedPrice)) {
        if (isOneTimeSelected) {
          // Update only the price-item--regular for one-time without discount
          $(".price-item--regular").text(`£${selectedPrice.toFixed(2)}`);
          console.log(
            "One-time price updated without discount:",
            selectedPrice
          );
        } else if (isSubscriptionSelected) {
          // If subscription is selected, apply a discount
          const discountedPrice = calculateDiscountedPrice(selectedPrice, 5);

          // Update the regular price with discounted price
          $(".price-item--regular").text(`£${discountedPrice}`);
          console.log(
            "Subscription price updated with discount:",
            discountedPrice
          );
        }
      } else {
        console.error("Invalid selectedPrice value:", selectedPriceText);
      }
    } else {
      console.error(
        "No price selected or invalid data attribute for compare-price."
      );
    }
  }

  // Function to apply subscription discount logic
  function applySubscriptionDiscount() {
    const isSubscriptionSelected =
      $(
        ".loop-widget-purchase-option.loop-widget-purchase-option-selected"
      ).not(".loop-widget-purchase-option-onetime").length > 0;

    const isOneTimeSelected =
      $(
        ".loop-widget-purchase-option-onetime.loop-widget-purchase-option-selected"
      ).length > 0;

    console.log("Subscription selected:", isSubscriptionSelected);
    console.log("One-time purchase selected:", isOneTimeSelected);

    updatePriceElements(isSubscriptionSelected, isOneTimeSelected);
  }

  // Function to update the selected price
  function updatePrice() {
    const selectedPriceText = $("input.quantity-radio:checked").data(
      "compare-price"
    );

    if (selectedPriceText) {
      const selectedPrice = parseFloat(
        selectedPriceText.replace(/[^\d.-]/g, "")
      );

      if (!isNaN(selectedPrice)) {
        // Update the price for one-time purchase (without affecting other prices)
        $(
          ".loop-widget-purchase-option-onetime .loop-widget-purchase-option-price"
        ).text(`£${selectedPrice.toFixed(2)}`);
        $(
          ".loop-widget-purchase-option .loop-widget-purchase-option-compare-at-price"
        ).text(`£${selectedPrice.toFixed(2)}`);

        // Apply discount for subscription
        const discountedPrice = calculateDiscountedPrice(selectedPrice, 5);
        $(
          "#loop-widget-purchase-option-id-6c819509c8de19993a9ff16dd38b8fb2fa1a7ee2 .loop-widget-purchase-option-price"
        ).text(`£${discountedPrice}`);

        console.log(
          "5% discounted price updated across all targets:",
          discountedPrice
        );
      } else {
        console.error("Invalid selectedPrice value:", selectedPriceText);
      }
    } else {
      console.error(
        "No price selected or invalid data attribute for compare-price."
      );
    }
  }

  // Initialize function to ensure elements are ready before applying logic
  let retryCount = 0;
  const maxRetries = 50;

  function initialize() {
    if (
      $(".price-item--regular").length > 0 &&
      $(".loop-widget-purchase-option").length > 0
    ) {
      applySubscriptionDiscount();
      updatePrice();

      // Attach event listeners
      $(document).on("change", ".loop-widget-sp-selector", function () {
        console.log("Frequency changed");
        applySubscriptionDiscount();
      });

      $(document).on("click", ".loop-widget-purchase-option", function () {
        setTimeout(applySubscriptionDiscount, 50); // Delay ensures state updates
      });
      $(document).on("click", ".loop-widget-purchase-option", function () {
        setTimeout(updatePrice, 50); // Delay ensures state updates
      });

      $("input.quantity-radio").on("change", function () {
        updatePrice();
        applySubscriptionDiscount();
      });

      console.log("Event listeners initialized.");
    } else {
      if (retryCount < maxRetries) {
        retryCount++;
        console.log(
          "Elements not ready, retrying... (" +
            retryCount +
            "/" +
            maxRetries +
            ")"
        );
        setTimeout(initialize, 100); // Retry after 100ms
      } else {
        console.warn(
          "Elements not ready after " +
            maxRetries +
            " attempts. Stopping retry."
        );
      }
    }
  }

  // Run on page load
  $(window).on("load", initialize);
});
